import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';

//Actions
import * as marketsActions from '../../actions/marketsActions';
import * as userActions from '../../actions/userActions';

//Components
import ManageMarketSection from './manageMarketsSection';

class Markets extends React.Component {
    constructor(props) {
		super(props);
        this.props.actions.getMarketsAllList();
	}

    getProducts(marketId) {
        let { products } = this.props.user.userInfo;

        if (!marketId) return products;

        if ( products && products.length )
            return products.filter( item => item.market_id == marketId);
    }

    render() {
        const { isLoggedIn, isSuperUser, isAdmin } = this.props.user;
        if (!(isLoggedIn && (isSuperUser || isAdmin))) return false;

        let markets = this.props.markets.manage;
        let { showManageMarketPopup } = this.props.actions;

        return (
            <div>
                <h1>Manage markets</h1>
                { markets && markets.length ? markets.map( item =>
                    <ManageMarketSection
                        key={'marketGroup_'+item.id}
                        data={item}
                        actions={this.props.actions}
                        products={item.products}
                        isAdmin={isAdmin} />
                ) : null }
                <div
                    onClick={showManageMarketPopup.bind(this, 'create')}
                    className='manage-market-create-row'>Create new market</div>
            </div>
        )
    }
}

export default connect(
    state => ({
        markets: state.markets,
        user: state.user,
    }),
    dispatch => ({
        actions: bindActionCreators({...marketsActions, ...userActions}, dispatch)
    })
)(Markets);



// WEBPACK FOOTER //
// ./source/screens/markets/manageMarkets.js